import { createAction } from '@reduxjs/toolkit';

export const APP_INITIALIZE = 'app-initialize';

export const appInitialize = createAction(APP_INITIALIZE);
